// extracted by mini-css-extract-plugin
export var embMisc = "MediaGallery-module--embMisc--d1629";
export var embMiscContainer = "MediaGallery-module--embMiscContainer--3520a";
export var embOtherMisc = "MediaGallery-module--embOtherMisc--691d4";
export var mainNavigationButton = "MediaGallery-module--mainNavigationButton--59ca5";
export var mainNavigationNextButton = "MediaGallery-module--mainNavigationNextButton--9c302";
export var mainNavigationPrevButton = "MediaGallery-module--mainNavigationPrevButton--c29fe";
export var mainSlide = "MediaGallery-module--mainSlide--f0905";
export var mainSlider = "MediaGallery-module--mainSlider--183d0";
export var mediaGallery = "MediaGallery-module--mediaGallery--34fc3";
export var misc = "MediaGallery-module--misc--c2791";
export var miscContainer = "MediaGallery-module--miscContainer--576b1";
export var modal = "MediaGallery-module--modal--1f8a9";
export var modalContentWrapper = "MediaGallery-module--modalContentWrapper--155fa";
export var nav = "MediaGallery-module--nav--a87bc";
export var pagination = "MediaGallery-module--pagination--35f7c";
export var thumbNavigationButton = "MediaGallery-module--thumbNavigationButton--98cf7";
export var thumbSlide = "MediaGallery-module--thumbSlide--f7631";
export var thumbs = "MediaGallery-module--thumbs--42556";
export var wrapper = "MediaGallery-module--wrapper--3d37e";